<template>
  <h2 :class="classObject">
    <span v-if="caption" class="caption">{{ caption }}</span>
    <span v-if="icon" class="icon"
      ><img :src="require(`@/assets/images/icon/${icon}.svg`)" alt=""
    /></span>
    <span v-html="text"></span>
  </h2>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'

export default defineComponent({
  name: 'HeadingLv2',

  props: {
    text: String,
    simple: {
      type: Boolean,
      default: false
    },
    bgBlue: {
      type: Boolean,
      default: false
    },
    icon: String,
    caption: String
  },

  setup(props) {
    const classObject = computed(() => {
      return {
        headingLv2: true,
        'headingLv2-simple': props.simple,
        'bg-blue': props.bgBlue,
        'hasCaption': props.caption
      }
    })

    return {
      classObject
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.headingLv2 {
  display: flex;
  align-items: flex-start;
  font-weight: 500;
  font-size: 2.2rem;
  line-height: 1.5;

  @include mixins.media() {
    font-size: 2.4rem;
  }

  img {
    margin-right: 14px;
    vertical-align: -5px;
  }

  &.bg-blue {
    align-items: center;
    margin-left: -16px;
    margin-right: -16px;
    margin-bottom: 12px;
    height: 50px;
    padding-left: 16px;
    padding-right: 16px;
    background-color: var.$color-secondary;
    font-size: 2rem;

    @include mixins.media() {
      margin-left: 0;
      margin-right: 0;
    }
  }

  &.hasCaption {
    flex-direction: column;
    align-items: center;
    .caption {
      font-size: 1.4rem;
    }
  }
}

.icon {
  flex-shrink: 0;
}

.headingLv2-simple {
  margin-top: 30px;
  margin-bottom: 20px;
  justify-content: center;
  text-align: center;

  @include mixins.media() {
    margin-top: 40px;
    margin-bottom: 40px;
  }
}
</style>
